
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 511.626 511.627"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M63.953 401.992H9.135c-2.666 0-4.853.855-6.567 2.567C.859 406.271 0 408.461 0 411.126v54.82c0 2.665.855 4.855 2.568 6.563 1.714 1.718 3.905 2.57 6.567 2.57h54.818c2.663 0 4.853-.853 6.567-2.57 1.712-1.708 2.568-3.898 2.568-6.563v-54.82c0-2.665-.856-4.849-2.568-6.566-1.714-1.712-3.904-2.568-6.567-2.568zM283.225 292.36h-54.818c-2.667 0-4.854.855-6.567 2.566-1.711 1.711-2.57 3.901-2.57 6.563v164.456c0 2.665.856 4.855 2.57 6.563 1.713 1.718 3.899 2.57 6.567 2.57h54.818c2.665 0 4.855-.853 6.563-2.57 1.711-1.708 2.573-3.898 2.573-6.563V301.49c0-2.662-.862-4.853-2.573-6.563-1.707-1.711-3.898-2.567-6.563-2.567zM173.589 365.451h-54.818c-2.667 0-4.854.855-6.567 2.566-1.711 1.711-2.568 3.901-2.568 6.563v91.358c0 2.669.854 4.859 2.568 6.57 1.713 1.711 3.899 2.566 6.567 2.566h54.818c2.663 0 4.853-.855 6.567-2.566 1.709-1.711 2.568-3.901 2.568-6.57V374.58c0-2.662-.859-4.853-2.568-6.563-1.714-1.71-3.905-2.566-6.567-2.566zM392.857 182.725h-54.819c-2.666 0-4.856.855-6.57 2.568-1.708 1.714-2.563 3.901-2.563 6.567v274.086c0 2.665.855 4.855 2.563 6.563 1.714 1.718 3.904 2.57 6.57 2.57h54.819c2.666 0 4.856-.853 6.563-2.57 1.718-1.708 2.57-3.898 2.57-6.563V191.86c0-2.666-.853-4.853-2.57-6.567-1.707-1.713-3.897-2.568-6.563-2.568zM509.06 39.115c-1.718-1.714-3.901-2.568-6.57-2.568h-54.816c-2.662 0-4.853.854-6.567 2.568-1.714 1.709-2.569 3.899-2.569 6.563v420.268c0 2.665.855 4.855 2.569 6.563 1.715 1.718 3.905 2.57 6.567 2.57h54.816c2.669 0 4.853-.853 6.57-2.57 1.711-1.708 2.566-3.898 2.566-6.563V45.679c0-2.664-.855-4.854-2.566-6.564z"}})])
          )
        }
      }
    